import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Hamburger = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  width: 48px;
  height: 48px;
  opacity: 1;
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  width: 100%;
  height: 100%;
  opacity: 1;

  &:active {
    outline: none;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
    border-radius: 16px;
  }
`;

export const Path = styled(motion.path)`
  fill: transparent;
  stroke: ${({ theme }) => theme.colors.grey6};
  stroke-width: 2;
  stroke-linecap: round;
`;
